import { render, staticRenderFns } from "./SecuritySettingsTab.vue?vue&type=template&id=a034b1fe"
import script from "./SecuritySettingsTab.vue?vue&type=script&lang=js"
export * from "./SecuritySettingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports